import React from "react"
import { Route } from "react-router-dom"
import Tools from "@/pages/Tools"
import ClearMessageQueueToolPage from "@/pages/Tools/ToolsPages/ClearMessageQueueToolPage"
import FindChatByProtocolToolPage from "@/pages/Tools/ToolsPages/FindChatByProtocolToolPage"
import MassNotifySubscriptionsToolPage from "@/pages/Tools/ToolsPages/MassNotifySubscriptionsToolPage"
import BlockUnblockMassSubscriptionsToolPage from "@/pages/Tools/ToolsPages/MassBlockAndUnblockToolPage"
import SearchForIntegrationsAndBotsByWebhookUrlToolPage from "@/pages/Tools/ToolsPages/SearchForIntegrationsAndBotsByWebhookUrlToolPage"
import CreateAdminAccountToolPage from "@/pages/Tools/ToolsPages/CreateAdminAccountToolPage"

const ToolsRoutes = [
	<Route
		key="tools"
		exact
		path="/tools"
		component={Tools}
	/>,
	<Route
		key="clear-message-queue-tool"
		exact
		path="/tools/clear-message-queue"
		component={ClearMessageQueueToolPage}
	/>,
	<Route
		key="find-chat-by-protocol"
		exact
		path="/tools/find-chat-by-protocol"
		component={FindChatByProtocolToolPage}
	/>,
	<Route
		key="mass-notify-subscriptions"
		exact
		path="/tools/mass-notify-subscriptions"
		component={MassNotifySubscriptionsToolPage}
	/>,
	<Route
		key="block-or-unblock-mass-subscriptions"
		exact
		path="/tools/block-or-unblock-mass-subscriptions"
		component={BlockUnblockMassSubscriptionsToolPage}
	/>,
	<Route
		key="search-integrations-or-bots-data-by-webhook-url"
		exact
		path="/tools/search-integrations-or-bots-data-by-webhook-url"
		component={SearchForIntegrationsAndBotsByWebhookUrlToolPage}
	/>,
	<Route
		key="create-admin-account"
		exact
		path="/tools/create-admin-account"
		component={CreateAdminAccountToolPage}
	/>
]

export default ToolsRoutes
